module.exports = __webpack_public_path__ + "e85f02f441decd2d687e5c718058406e.svg";